import React from 'react';
import styled, {
  keyframes,
} from 'styled-components';
import WayPoint from 'react-waypoint';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    visibility: hidden;
    -webkit-transform: translate3d(0, 40px, 0);
    transform: translate3d(0, 40px, 0);
  }
  to {
    visibility: visible;
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
`;

const Wrap = styled.div`
  visibility: visible;
  animation: ${fadeInUp} 0.75s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
`;

export default class extends React.Component {
  state = {
    entered: false,
  }

  enterHandler = () => {
    if (this.state.entered) {
      return;
    }
    this.setState({ entered: true });
  }

  renderChildren() {
    if (!this.state.entered) return null;
    const { children } = this.props;
    return React.Children.map(children, (child, i) =>
      (
        <Wrap style={{ transitionDelay: (children.length ? i / children.length : 0) }}>
          {child}
        </Wrap>
      )
    );
  }

  render() {
    return (
      <WayPoint onEnter={this.enterHandler}>
        <div>
          {this.renderChildren()}
        </div>
      </WayPoint>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Animation/FadeInUp.js